export default __webpack_public_path__ + "assets/2512faccfd34a536dfb8bf2b00b9738a.svg";